<template>
  <RelatorioSalesOrderView />
</template>

<script>
import RelatorioSalesOrderView from "@/views/relatorioSalesOrder/RelatorioSalesOrderView.vue";
import relatorioPermissionMixin from "@/mixins/relatorioPermissionMixin";

export default {
  name: "RelatorioComercialSalesOrderView",
  mixins: [relatorioPermissionMixin],
  components: {
    RelatorioSalesOrderView
  },
  data() {
    return {
      relatorioSchemas: ["SalesOrder", "SolicitacaoDeOrcamento"],
      relatorioFiltrarPorOwner: false
    };
  }
};
</script>
